
// In PreviewAttachments.tsx
import CloudDownloadIcon from '@mui/icons-material/CloudDownload'
import { Box, IconButton, Stack, Tooltip, useTheme } from '@mui/material'
import React from 'react'
import { CommentData } from 'types'
import { useDownloadAttachment } from '../../api/aws/comments/useDownloadAttachments'
import AttachmentThumb from './AttachmentThumb'
import RenderAttachmentThumbnail from './RenderAttachmentThumbnail'

interface Attachments {
  id: string
  iconLink: string
  mimeType: string
  name: string
  thumbnailLink: string
  url: string
}

interface ThumbnailProps {
  note: CommentData
  onOpenViewer: (index: number) => void
  onDeleteAttachment: (index: number) => void
  isNoteCreator: boolean
}
const getThumbnail = (attachment: Attachments) => <AttachmentThumb attachment={attachment} />

// const getThumbnail = (attachment: Attachments) => {
//   const url = attachment.thumbnailLink || attachment.url
//   const mime = typeof attachment.mimeType === 'string' ? attachment.mimeType : ''
//   const name = attachment.name?.toLowerCase() || ''

//   if (mime?.startsWith('image/') || /\.(svg|png|jpe?g|gif)$/i.test(name)) {
//     return (
//       <Box
//         component="img"
//         src={url}
//         alt={attachment.name}
//         sx={{
//           // width: '100%',
//           // height: '100%',
//           maxHeight: 24,
//           borderRadius: 1,
//           objectFit: 'cover',
//           transition: 'transform 0.2s ease',
//         }}
//       />
//     )
//   } else if (mime === 'application/pdf' || name.endsWith('.pdf')) {
//     return (
//       <img
//         src={attachment.thumbnailLink || PictureAsPdfIcon}
//         alt="PDF File"
//         style={{
//           height: '100%',
//           width: '100%',
//           objectFit: 'cover',
//         }}
//       />
//     )
//   } else if (mime.includes('word') || name.endsWith('.doc') || name.endsWith('.docx')) {
//     return <DescriptionIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
//   } else {
//     return <DescriptionIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
//   }
// }
const PreviewAttachments: React.FC<ThumbnailProps> = ({ note, onOpenViewer, onDeleteAttachment, isNoteCreator }) => {
  const theme = useTheme()
  const { downloadAttachment, downloadAllAttachments } = useDownloadAttachment()
  const attachmentSize = note?.attachments?.length
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
      }}
    >
      {/* Attachments grid */}
      <Stack
        direction="row"
        spacing={2}
        useFlexGap
        flexWrap="wrap"
        sx={{ alignItems: 'center', justifyContent: 'flex-start', width: '100%' }}
      >
        {note?.attachments?.map((attachment, index) => (
          <RenderAttachmentThumbnail
            key={`${index}-${attachment.url}`}
            attachment={attachment}
            attachmentIndex={index}
            onDeleteAttachment={onDeleteAttachment}
            onOpenViewer={onOpenViewer}
            getThumbnail={getThumbnail}
            isNoteCreator={isNoteCreator}
          />
        ))}

        {note.attachments?.length > 1 && (
          <Tooltip title="Download All as ZIP">
            <IconButton
              onClick={e => {
                e.stopPropagation()
                downloadAllAttachments(note.attachments, `${note.note_id}_attachments.zip`)
              }}
              sx={{
                width: 24,
                height: 24,
                borderRadius: 1,
                border: '1px solid',
                borderColor: theme => theme.palette.divider,
              }}
            >
              <CloudDownloadIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Stack>
    </Box>
  )
}

export default PreviewAttachments
